import React from 'react'

const ParametreContent = () => {
  return (
    <div>ParametreContent</div>
  )
}

export default ParametreContent